import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { message } from "antd";
import { GET_USER_NEW, HEADERS_EXPORT_BEN } from "../component/API/apiUrls";
import TokenCheck from "./TokenCheck";

export default function useLawyerNamesNew({ auto = true, toast = false } = {}) {
  const [nameLawyers, setNameLawyers] = useState([]);
  const [loadingUseLawyerNames, setLoadingUseLawyerNames] = useState(false);
  const [error, setError] = useState(null);
  const [signOut] = TokenCheck();

  const refresh = useCallback(async () => {
    const controller = new AbortController();
    setLoadingUseLawyerNames(true);
    setError(null);

    try {
      const res = await axios.get(GET_USER_NEW, {
        headers: HEADERS_EXPORT_BEN,
        signal: controller.signal,
      });
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      console.log("useLawyerNamesNew", data);

      setNameLawyers(data);
      if (toast && data.length === 0) message.warning("ไม่มีข้อมูลรายชื่อทนาย");
    } catch (e) {
      if (e.response?.data === "Session expired") {
        signOut();
      } else {
        // เคลียร์ค่า state กลับเป็นค่าว่างเพื่อไม่ให้มีข้อมูลเก่าค้าง
        console.error("Error fetching lawyers data:", e);
        // แจ้งเตือนข้อผิดพลาด
        const errorMessage =
          error.response?.data?.message ||
          "เกิดข้อผิดพลาดในการดึงข้อมูลทนายความ";
        message.error(errorMessage);
      }
    } finally {
      setLoadingUseLawyerNames(false);
    }

    return () => controller.abort();
  }, [toast]);

  useEffect(() => {
    if (auto) refresh();
  }, [auto, refresh]);

  return { nameLawyers, loadingUseLawyerNames, error, refresh };
}
